import { normalizeRid, ownedBy } from '../../../shared/model/scopeKeys'

/**
 * Ключи намерения поставок: каждый начинается с rid (D-064). Одна и та же
 * поставка/строка (одинаковые GUID) в двух базах — две записи, и очистка
 * одной базы другую не трогает.
 */
export { normalizeRid, ownedBy }

const id = (value: string) => value.trim().toLowerCase()

export const ridKey = (resourceId: string) => `${normalizeRid(resourceId)}|`
export const supplyKey = (resourceId: string, supplyId: string) => `${normalizeRid(resourceId)}|${id(supplyId)}`
export const lineKey = (resourceId: string, supplyId: string, lineId: string) =>
  `${supplyKey(resourceId, supplyId)}|${id(lineId)}`
export const commandKey = (resourceId: string, supplyId: string, kind: string, detail?: string) =>
  `${supplyKey(resourceId, supplyId)}|${kind}${detail === undefined ? '' : `|${detail}`}`
/** Ключ набранной цены строки по виду цены. */
export const priceKey = (lineId: string, priceTypeKey: string) => `${id(lineId)}|${id(priceTypeKey)}`

/** Запись относится к этой поставке этой базы. */
export const ofSupply = (key: string, resourceId: string, supplyId: string) =>
  key === supplyKey(resourceId, supplyId) || key.startsWith(`${supplyKey(resourceId, supplyId)}|`)
